export default "__VITE_ASSET__DQFKqHhP__"